import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Table
 *
 * @param {StyledProps} props - children, padding, size, stickyHeader
 * @example
 * <Table
 * 	id=""
 * 	padding={'normal' || 'checkbox' || 'none'}
 * 	size={'medium'}
 * 	stickyHeader={false || true}
 * >
 * 	{children}
 * </Table>
 * @returns React.ReactElement
 */
var Table = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Table.defaultProps = {
    id: "",
    padding: 'normal',
    size: 'medium',
    stickyHeader: false,
};
var SampleProps = {};
export default Table;
export { SampleProps as TableSample, };
